import React from "react";

const InfoRow = (icon: string, labelKey: string, value: React.ReactNode, extra?: React.ReactNode) => {
  return (
    <div className="d-flex justify-content-between align-items-center border-bottom mb-3 pb-2 s-regular">
      <div className="me-2">
        <i className={`${icon} blue-font me-2`} />
        {labelKey}
      </div>
      <div className=" d-flex align-items-center">
        <span>{value === null || value === undefined || value === "" ? "N/A" : value}</span>
        {extra && <span className="ms-2">{extra}</span>}
      </div>
    </div>
  );
};

export default InfoRow;
